/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Admin_Shared_Time_Ago_In_HoursInputs */

const en_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}h ago`)
};

const de_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.hours}h`)
};

const es_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hace ${i?.hours}h`)
};

const fr_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il y a ${i?.hours}h`)
};

const nl_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}u geleden`)
};

const it_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}h fa`)
};

const pt_br2_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.hours}h`)
};

const pl_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}h temu`)
};

const hu_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} órája`)
};

const ro_admin_shared_time_ago_in_hours = /** @type {(inputs: Admin_Shared_Time_Ago_In_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`acum ${i?.hours}h`)
};

/**
* | output |
* | --- |
* | "{hours}h ago" |
*
* @param {Admin_Shared_Time_Ago_In_HoursInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_time_ago_in_hours = /** @type {((inputs: Admin_Shared_Time_Ago_In_HoursInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Time_Ago_In_HoursInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_time_ago_in_hours(inputs)
	if (locale === "de") return de_admin_shared_time_ago_in_hours(inputs)
	if (locale === "es") return es_admin_shared_time_ago_in_hours(inputs)
	if (locale === "fr") return fr_admin_shared_time_ago_in_hours(inputs)
	if (locale === "nl") return nl_admin_shared_time_ago_in_hours(inputs)
	if (locale === "it") return it_admin_shared_time_ago_in_hours(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_time_ago_in_hours(inputs)
	if (locale === "pl") return pl_admin_shared_time_ago_in_hours(inputs)
	if (locale === "hu") return hu_admin_shared_time_ago_in_hours(inputs)
	return ro_admin_shared_time_ago_in_hours(inputs)
});
export { admin_shared_time_ago_in_hours as "admin.shared.time_ago_in_hours" }